import React from 'react'
import NnPianoApp from './NnPianoApp'
import { Redirect, Route, Switch } from 'react-router-dom'
import SongManager from './music/SongManager'
import * as qs from 'query-string'

const SONG_INDEX_FILENAME = '/Songs/Song Paths For App.csv'
class App extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <Switch>
                <Route
                    exact
                    path="/"
                    render={() => <Redirect to="/song/Bingo?skin=tech" />}
                />
                <Route
                    path="/song/:songId"
                    render={({ location, match }) => {
                        const { skin, timing, letters } = qs.parse(
                            location.search
                        )
                        const songId = match.params.songId
                        return (
                            <NnPianoApp
                                songId={songId}
                                songs={this.state.songs}
                                skin={skin}
                                timing={typeof timing !== 'undefined'}
                                letters={typeof letters !== 'undefined'}
                            />
                        )
                    }}
                />
            </Switch>
        )
    }

    componentDidMount() {
        SongManager.loadSongIndex(SONG_INDEX_FILENAME).then(index =>
            this.setState({ songs: index })
        )
        console.log(this.props.songs)
    }
}
export default App
